
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ItemsActionNames } from '@/definitions/app/item.actions.name';
import { UserFaceUpdate } from '@/api';
import { ThumbnailAction } from '@/uikit/thumbnail';
import { ThumbnailPositions } from '@/uikit/thumbnail/helpers/enums';
import NThumbnail from '@/uikit/thumbnail/NThumbnail.vue';
import { UserFaceRequestWithThumbnail } from '@/pages/users/types';

@Options({
  components: { NThumbnail }
})
export default class UserFace extends Vue {
  @Prop({ type: Object, required: true })
  readonly face!: UserFaceUpdate | UserFaceRequestWithThumbnail;

  @Prop({ type: Boolean, default: false })
  readonly isCover!: false;

  private defaultAction = ItemsActionNames.ShowFullScreen;

  get actions() {
    let actions: ThumbnailAction[] = [
      { icon: 'trash', name: ItemsActionNames.Remove, position: ThumbnailPositions.TopRight },
      { icon: 'eye-open', name: ItemsActionNames.ShowFullScreen, position: ThumbnailPositions.BottomLeft }
    ];
    
    if (!this.isCover) {
      actions.push({ icon: 'main-picture', name: ItemsActionNames.SetCover, position: ThumbnailPositions.BottomRight });
    }

    return actions;
  }
}
